var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ModalConfirmation',_vm._b({attrs:{"title":"Apagar Campanha","body":"Tem certeza que deseja apagar essa campanha?"}},'ModalConfirmation',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }